import React from "react";
import { Button } from "@chakra-ui/react";

export const LaunchInstructionExternal = (props) => {
  return (
    <Button
      colorScheme="blue"
      className="no-print"
      pos="fixed"
      bottom="0"
      right={4}
      zIndex="1000"
      mb={4}
      tabIndex="1"
      onClick={() =>
        window.open(
          `${window.location.href.split("?")[0]}?id=${props.instructionKey}`,
          "_blank"
        )
      }
    >
      Open in new window
    </Button>
  );
};
